<div class="row">
  <h6 style="margin-left: 25px">
    <span style="color: #f49602">&#9679;</span>
    &nbsp; Please add the boundary conditions
  </h6>

  <div class="col-md-12 col-xl-6">
    <usimweb-button text="Add boundary" (btnClick)="addRow()">Add boundary</usimweb-button>

    <!-- <table
      aria-label="parameterTable"
      mat-table
      [dataSource]="dataTableSource"
      class="mat-elevation-z8"
      style="margin-top: 15px"
    >
      <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef>Active</th>
        <td mat-cell *matCellDef="let model"> -->
    <!-- <p>Index: {{ model.index }}</p> -->

    <!-- <usimweb-checkbox
            *ngIf="activeIndex === model.index"
            (onChange)="activate(model.index)"
            [(ngModel)]="'true'"
          ></usimweb-checkbox>

          <usimweb-checkbox
            *ngIf="activeIndex !== model.index"
            (onChange)="activate(model.index)"
            [(ngModel)]="'false'"
          ></usimweb-checkbox> -->
    <!-- </td>
      </ng-container> -->

    <!-- <ng-container matColumnDef="boundary_condition">
        <th mat-header-cell *matHeaderCellDef>Boundary Condition</th>
        <td mat-cell *matCellDef="let model">
          <usimweb-dropdown
            placeholder="Boundary Condition"
            [values]="values"
            [key]="key"
            [value]="value"
            [default]="'-'"
            (selectionChange)="changeBoundaryType($event, model.index)"
            [required]="true"
          ></usimweb-dropdown>
        </td>
      </ng-container>

      <ng-container matColumnDef="line_color">
        <th mat-header-cell *matHeaderCellDef>Line Color</th>
        <td mat-cell *matCellDef="let model">
          <div
            style.background-color="rgb({{ model.line_color.r }}, {{ model.line_color.g }}, {{ model.line_color.b }})"
            style="height: 10px; width: 10px"
          ></div>
        </td>
      </ng-container> -->

    <!-- <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let model">{{ model.data }}</td>
      </ng-container> -->

    <!-- <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef>Delete</th>
        <td mat-cell *matCellDef="let model">
          <usimweb-button text="Delete" (btnClick)="deleteRow(model.index)"></usimweb-button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="curveColumnsTable"></tr>
      <tr mat-row *matRowDef="let row; columns: curveColumnsTable"></tr>
    </table> -->
  </div>

  <div class="col-md-12 col-xl-6" style="position: relative; height: 90%">
    <ceetron-viewer #viewer [modelId]="'1'" *ngIf="loadViewer" style="display: inline-block"></ceetron-viewer>
  </div>
</div>

<usimweb-button text="change drawstyle" (btnclick)="drawstyle()"></usimweb-button>
